<template>
  <div class="formCom" v-if="show == null">
    <div class="form">
      <div class="kit-id">
        Kit ID {{convertKitId(this.KitInfo.kit_id)}}
      </div>
      <div class="kit-id archive">
        Archive?
      </div>
      <textarea
        class="input"
        placeholder="Reason.."
        v-model="txt"
      ></textarea>
      <div class="button-wrap">
        <button class="btn" @click="closeConfurmModal">
          <CloseIcone></CloseIcone>
        </button>
        <button class="btn" @click="remove">
          <img src="../../images/dashboard/done.png" alt="#" />
        </button>
      </div>
    </div>
  </div>
  <div class="formCom" v-else>
    <div class="form-btn">
      <div class="kit-id">
        {{show}}
      </div>
      <button class="saveBtn" @click="done">Ok</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import CloseIcone from "../../images/shared/cancel";
import { parseAndConvertKitId } from "../mixins/parseAndConvertKitId";
export default {
  props: ["KitInfo"],  
  mixins: [parseAndConvertKitId],
  data() {
    return {
      show:null,
      CommentTxt: "",
      txt: ""
    }
  },
  components: {
    CloseIcone
  },
  methods: {
    ...mapActions(["archiveKit", "getAdminInfoList"]),
    closeConfurmModal() {
      this.$emit("closeAchriveConfurmModal", false);
    },
    remove() {
      const data = {
        kit_id: this.KitInfo.id,
        reason_archive: this.txt
      };
      this.archiveKit({ data }).then(res => {
        this.show = "Test Kit "+this.convertKitId(this.KitInfo.kit_id)+" has been archived.";
      });
    },
    done(){
      this.getAdminInfoList().then(res => {
          this.$emit("closeAchriveConfurmModal", false);
        });
    }
  }
};
</script>

<style scoped>
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 410px;
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 10px;
}
.form-btn {
  padding: 30px;
  background-color: #fff;
  max-width: 710px;
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 10px;
}
.button-wrap {
  width: 50%;
  margin: 10px auto 15px auto;
  display: flex;
  justify-content: space-around;
}
.kit-id {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 10px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.kit-id.archive {
  margin: 0 0 15px 0;
}
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 1px solid transparent;
  cursor: pointer;
}
.btn img {
  max-width: 100%;
  height: 100%;
}
.saveBtn {
  outline: none;
  border: 1px solid transparent;
  color: #fff;
  width: 150px;
  height: 45px;
  margin: 25px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #62b039;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.saveComment {
  color: green;
  margin: 10px 0 0 0;
  text-align: center;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.input {
  resize: none;
  height: 150px;
  padding: 15px 20px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  border: 1px solid #e4e4e4;
  outline: none;
  border-radius: 2px;
}
.input::placeholder {
  color: #98a4ae;
}
</style>
